var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoatHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29478",
    "data-name": "Group 29478",
    transform: "translate(-421.999 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29477",
    "data-name": "Group 29477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(421.999 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29419",
    "data-name": "Group 29419",
    transform: "translate(367.234 -1.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50790",
    "data-name": "Path 50790",
    d: "M3141,2859.766h1.763V2858H3141Z",
    transform: "translate(-3060.951 -2339.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50791",
    "data-name": "Path 50791",
    d: "M2975.516,2693.764h-2.265a.25.25,0,0,1-.251-.248v-2.265a.253.253,0,0,1,.251-.251h2.265a.25.25,0,0,1,.248.251v2.265A.247.247,0,0,1,2975.516,2693.764Z",
    transform: "translate(-2893.453 -2172.745)",
    fill: "#df6b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50792",
    "data-name": "Path 50792",
    d: "M3817.262,2693.764H3815V2691h2.262a.253.253,0,0,1,.251.251v2.265A.25.25,0,0,1,3817.262,2693.764Z",
    transform: "translate(-3732.937 -2172.745)",
    fill: "#80b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50793",
    "data-name": "Path 50793",
    d: "M2975.516,1936.761h-2.265a.25.25,0,0,1-.251-.248v-2.265a.25.25,0,0,1,.251-.248h2.265a.247.247,0,0,1,.248.248v2.265A.247.247,0,0,1,2975.516,1936.761Z",
    transform: "translate(-2893.453 -1418.008)",
    fill: "#eab14d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50794",
    "data-name": "Path 50794",
    d: "M3817.262,1936.761H3815V1934h2.262a.25.25,0,0,1,.251.248v2.265A.25.25,0,0,1,3817.262,1936.761Z",
    transform: "translate(-3732.937 -1418.008)",
    fill: "#b3e59f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50795",
    "data-name": "Path 50795",
    d: "M2975.516,1178.764h-2.265a.252.252,0,0,1-.251-.251v-2.262a.252.252,0,0,1,.251-.251h2.265a.25.25,0,0,1,.248.251v2.262A.25.25,0,0,1,2975.516,1178.764Z",
    transform: "translate(-2893.453 -662.272)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50796",
    "data-name": "Path 50796",
    d: "M3817.262,1178.764H3815V1176h2.262a.253.253,0,0,1,.251.251v2.262A.253.253,0,0,1,3817.262,1178.764Z",
    transform: "translate(-3732.937 -662.272)",
    fill: "#df6b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50783",
    "data-name": "Path 50783",
    d: "M799.238,1301.994h-1.987a.25.25,0,0,1-.251-.248v-2.184a.564.564,0,0,1,.565-.562h1.359a.564.564,0,0,1,.565.562v2.184A.25.25,0,0,1,799.238,1301.994Z",
    transform: "translate(-723.955 -784.904)",
    fill: "#d62966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50784",
    "data-name": "Path 50784",
    d: "M320.122,2137.132h-4.874a.25.25,0,0,1-.248-.251v-2.214a.666.666,0,0,1,.663-.667h4.043a.666.666,0,0,1,.663.667v2.214A.25.25,0,0,1,320.122,2137.132Z",
    transform: "translate(-243.396 -1617.409)",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50785",
    "data-name": "Path 50785",
    d: "M131.919,3019.492a.255.255,0,0,1-.191-.087,4.766,4.766,0,0,1-.347-.559l-2.734-4.171c-.245-.358-.045-.675.284-.675h5.725a.966.966,0,0,1,.693.385l.663.914h8.376a.25.25,0,0,1,.242.311h2.456a.25.25,0,0,1,.242-.311h1.443a.249.249,0,0,1,.209.383l-2,3.161-.149.26a.249.249,0,0,1-.412.033l-7,.95-7.264-.789A.248.248,0,0,1,131.919,3019.492Z",
    transform: "translate(-57.491 -2494.78)",
    fill: "#d62966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50786",
    "data-name": "Path 50786",
    d: "M890.329,4346.5,890,4346h16.718l-.317.5Z",
    transform: "translate(-816.677 -3822.8)",
    fill: "#c1255c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50787",
    "data-name": "Path 50787",
    d: "M15.347,4570.218c-1.515,0-2.074-.756-3.469-.756s-1.954.756-3.469.756-2.071-.756-3.466-.756-1.954.756-3.469.756a3.83,3.83,0,0,1-1.862-.413c-.117-.069-.1-.2-.087-.34.027-.484-.024-1.921,0-1.963a.248.248,0,0,1,.341-.09,3.385,3.385,0,0,0,1.608.344c1.4,0,1.954-.756,3.469-.756s2.071.756,3.466.756,1.954-.756,3.469-.756,2.071.756,3.466.756S17.3,4567,18.813,4567a3.869,3.869,0,0,1,1.862.412c.117.072.087.207.087.344v1.96c0,.141-.221.162-.341.089a3.386,3.386,0,0,0-1.608-.343C17.415,4569.462,16.862,4570.218,15.347,4570.218Z",
    transform: "translate(71.144 -4043.14)",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50788",
    "data-name": "Path 50788",
    d: "M1542.022,3772.255h-.395a.628.628,0,0,1,0-1.255h.395a.628.628,0,0,1,0,1.255Zm3.463,0h-.395a.628.628,0,0,1,0-1.255h.395a.628.628,0,0,1,0,1.255Zm3.463,0h-.391a.628.628,0,0,1,0-1.255h.391a.628.628,0,0,1,0,1.255Zm3.466,0h-.394a.628.628,0,1,1,0-1.255h.394a.628.628,0,0,1,0,1.255Z",
    transform: "translate(-1465.732 -3249.519)",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50789",
    "data-name": "Path 50789",
    d: "M15.347,5182.215c-1.515,0-2.074-.756-3.469-.756s-1.954.756-3.469.756-2.071-.756-3.466-.756-1.954.756-3.469.756a3.83,3.83,0,0,1-1.862-.412c-.117-.068-.1-.2-.087-.34.027-.484-.024-1.921,0-1.963a.249.249,0,0,1,.341-.09,3.385,3.385,0,0,0,1.608.344c1.4,0,1.954-.753,3.469-.753s2.071.753,3.466.753,1.954-.753,3.469-.753,2.071.753,3.466.753S17.3,5179,18.813,5179a3.836,3.836,0,0,1,1.862.412c.117.069.087.2.087.341v1.963c0,.137-.221.158-.341.086a3.391,3.391,0,0,0-1.608-.344C17.415,5181.459,16.862,5182.215,15.347,5182.215Z",
    transform: "translate(71.144 -4653.311)",
    fill: "#d3effb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50797",
    "data-name": "Path 50797",
    d: "M4761.487,820.366a.253.253,0,0,1-.068-.012A5.1,5.1,0,0,1,4759,818.77a3.968,3.968,0,0,1-1-2.519v-2.815a.237.237,0,0,1,.149-.224,12.03,12.03,0,0,0,3.17-1.9.248.248,0,0,1,.334,0,12.039,12.039,0,0,0,3.173,1.9.239.239,0,0,1,.146.224v2.815a4.666,4.666,0,0,1-3.416,4.1A.293.293,0,0,1,4761.487,820.366Z",
    transform: "translate(-4673.119 -298.612)",
    fill: "#335f8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50798",
    "data-name": "Path 50798",
    d: "M5068.566,1231.017a.231.231,0,0,1-.077-.012,3.525,3.525,0,0,1-2.489-3.054v-2.095a.243.243,0,0,1,.144-.221,10.778,10.778,0,0,0,2.268-1.33.243.243,0,0,1,.311,0,10.756,10.756,0,0,0,2.265,1.33.241.241,0,0,1,.146.221v2.095a3.522,3.522,0,0,1-2.492,3.054A.208.208,0,0,1,5068.566,1231.017Z",
    transform: "translate(-4980.199 -710.378)",
    fill: "#5684b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50799",
    "data-name": "Path 50799",
    d: "M5454.566,2039.475a.248.248,0,0,1-.234-.17l-.316-1a.245.245,0,0,1,.158-.308.25.25,0,0,1,.308.158l.21.666,1.8-1.428a.244.244,0,0,1,.3.382l-2.077,1.646A.242.242,0,0,1,5454.566,2039.475Z",
    transform: "translate(-5367.043 -1521.038)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatHighlighted);
export default __webpack_public_path__ + "static/media/boatHighlighted.1261933e7547bf089bb40b475efb4994.svg";
export { ForwardRef as ReactComponent };